import { IRoute, RouterItemPg, TokenService } from 'viggo-sistemas-core-web';
// eslint-disable-next-line import/no-cycle
import {
  filterGrantMenuItens,
  filterGrantSubMenuItens,
  ordemAlfabetica,
  ordemPrecendecia
} from '../menu.service';

export class MenuAdmin {
  constructor(protected tokenService: TokenService) {}

  /**
   * Menu de cadastros (participantes e expedição)
   * @param routes
   * @returns
   */
  createMenuCadastros(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantSubMenuItens(routes, [
      {
        menuItem: {
          icon: 'mdi mdi-handshake-outline',
          label: 'Participantes',
          routerLink: null,
          isSubMenu: true,
          idElement: 'menu-participantes',
          items: [
            {
              icon: 'mdi mdi-face-agent',
              isSubMenu: false,
              label: 'Atendentes',
              routerLink: ['/atendentes'],
              idElement: 'menu-parceiro-atendentes',
              backend_config: [
                {
                  url: '/atendentes',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              icon: 'mdi mdi-doctor',
              isSubMenu: false,
              label: 'Profissionais',
              routerLink: ['/profissionais'],
              idElement: 'menu-parceiro-profissionais',
              backend_config: [
                {
                  url: '/profissionais',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              icon: 'mdi mdi-account',
              isSubMenu: false,
              label: 'Pacientes',
              routerLink: ['/pacientes'],
              idElement: 'menu-parceiro-pacientes',
              backend_config: [
                {
                  url: '/pacientes',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              icon: 'mdi mdi-domain',
              isSubMenu: false,
              label: 'Fornecedores',
              routerLink: ['/fornecedores'],
              idElement: 'menu-parceiro-fornecedores',
              backend_config: [
                {
                  url: '/fornecedores',
                  method: 'POST'
                }
              ],
              precedence: 1
            }
          ]
        },
        matchBackendRoutes: [
          {
            url: '/fornecedores',
            method: 'POST'
          },
          {
            url: '/atendentes',
            method: 'POST'
          },
          {
            url: '/profissionais',
            method: 'POST'
          },
          {
            url: '/pacientes',
            method: 'POST'
          }
        ]
      },
      {
        menuItem: {
          icon: 'mdi mdi-view-dashboard-edit-outline',
          label: 'Parametrizações',
          routerLink: null,
          isSubMenu: true,
          idElement: 'menu-parametrizacoes',
          items: [
            {
              icon: 'mdi mdi-receipt-text-outline',
              isSubMenu: false,
              label: 'Protocolos',
              routerLink: ['/protocolos'],
              idElement: 'menu-parametrizacao-protocolos',
              backend_config: [
                {
                  url: '/protocolos',
                  method: 'POST'
                }
              ],
              precedence: 1
            },
            {
              icon: 'mdi mdi-bandage',
              isSubMenu: false,
              label: 'Procedimentos',
              routerLink: ['/procedimentos'],
              idElement: 'menu-parametrizacao-procedimentos',
              backend_config: [
                {
                  url: '/procedimentos',
                  method: 'POST'
                }
              ],
              precedence: 2
            },
            {
              icon: 'mdi mdi-hospital-building',
              isSubMenu: false,
              label: 'Planos de saúde',
              routerLink: ['/planos_saude'],
              idElement: 'menu-parametrizacao-planos-saude',
              backend_config: [
                {
                  url: '/planos_saude',
                  method: 'POST'
                }
              ],
              precedence: 3
            },
            {
              icon: 'mdi mdi-note-outline',
              isSubMenu: false,
              label: 'Formulários',
              routerLink: ['/formularios'],
              idElement: 'menu-parametrizacao-formularios',
              backend_config: [
                {
                  url: '/formularios',
                  method: 'POST'
                }
              ],
              precedence: 4
            },
            {
              icon: 'pi pi-fw pi-times-circle',
              isSubMenu: false,
              label: 'Motivo Cancelamento',
              routerLink: ['/motivos_cancelamento'],
              idElement: 'menu-parametrizacao-motivo-cancelamento',
              backend_config: [
                {
                  url: '/motivos_cancelamento',
                  method: 'POST'
                }
              ],
              precedence: 4
            }
          ]
        },
        matchBackendRoutes: [
          {
            url: '/protocolos',
            method: 'POST'
          },
          {
            url: '/procedimentos',
            method: 'POST'
          },
          {
            url: '/planos_saude',
            method: 'POST'
          },
          {
            url: '/formularios',
            method: 'POST'
          }
          ,
          {
            url: '/motivos_cancelamento',
            method: 'POST'
          }
        ]
      }
    ]);
    submenu.sort(ordemAlfabetica);

    if (submenu.length > 0)
      menu = {
        label: 'Cadastros',
        icon: 'mdi mdi-plus-box-multiple-outline',
        isSubMenu: true,
        routerLink: null,
        items: submenu,
        idElement: 'menu-cadastros'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de suprimentos
   * @param routes Rotas permitidas ao usuário
   */
  createMenuMaterial(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Cadastro de materiais',
          isSubMenu: false,
          routerLink: ['/materiais'],
          icon: 'mdi mdi-medication-outline',
          idElement: 'menu-materiais',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/materiais'
          }
        ]
      },
      {
        menuItem: {
          label: 'Entrada de estoque dos materiais',
          isSubMenu: false,
          routerLink: ['/ree_materiais'],
          icon: 'mdi mdi-archive-arrow-down-outline',
          idElement: 'menu-ree-materiais',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/ree_materials'
          }
        ]
      },
      {
        menuItem: {
          label: 'Saída de estoque dos materiais',
          isSubMenu: false,
          routerLink: ['/rse_materiais'],
          icon: 'mdi mdi-archive-arrow-up-outline',
          idElement: 'menu-rse-materiais',
          precedence: 3
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/rses_material'
          }
        ]
      }
    ]);

    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        icon: 'mdi mdi-medication-outline',
        label: 'Materiais',
        routerLink: null,
        items: submenu,
        idElement: 'menu-material'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de suprimentos
   * @param routes Rotas permitidas ao usuário
   */
  createMenuFinanceiro(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Portadores',
          isSubMenu: false,
          routerLink: ['/portadores'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-portadores',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/portadores'
          }
        ]
      },
      {
        menuItem: {
          label: 'Contas à receber',
          isSubMenu: false,
          routerLink: ['/contas-receber'],
          precedence: 1,
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-conta-receber'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/conta_recebers'
          }
        ]
      },
      {
        menuItem: {
          label: 'Contas a pagar',
          isSubMenu: false,
          routerLink: ['/contas-pagar'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-contapagar',
          backend_url_route: '/conta_pagars'
        },
        matchBackendRoutes: [
          {
            method: 'GET',
            url: '/conta_pagars'
          }
        ]
      },
      {
        menuItem: {
          label: 'Movimentação financeira',
          isSubMenu: false,
          routerLink: ['/movimentacao_financeira'],
          icon: 'pi pi-fw pi-money-bill',
          idElement: 'menu-movimentacao-financeira',
          precedence: 2
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/movimentacao_financeiras'
          }
        ]
      }
    ]);
    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        icon: 'mdi mdi-currency-brl',
        label: 'Financeiro',
        routerLink: null,
        items: submenu,
        idElement: 'menu-financeiro'
      };

    return menu;
  }

  /**
   * Gera o menu do módulo de suprimentos
   * @param routes Rotas permitidas ao usuário
   */
  createMenuEmpresa(routes: IRoute[]) {
    let menu: RouterItemPg;

    let submenu = [] as RouterItemPg[];

    submenu = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Dados da Empresa',
          isSubMenu: false,
          routerLink: ['/dados-empresa/editar'],
          icon: 'pi pi-fw pi-building',
          idElement: 'menu-dados-empresa',
          precedence: 1
        },
        matchBackendRoutes: [
          {
            method: 'PUT',
            url: '/domains/<id>'
          }
        ]
      },
      {
        menuItem: {
          label: 'Regras de negócio',
          isSubMenu: false,
          routerLink: ['/dados-empresa/settings'],
          precedence: 1,
          icon: 'pi pi-fw pi-briefcase',
          idElement: 'menu-settings'
        },
        matchBackendRoutes: [
          {
            url: '/domains/<id>',
            method: 'PUT'
          },
          {
            url: '/domains/<id>/settings',
            method: 'PUT'
          }
        ]
      }
    ]);
    submenu.sort(ordemPrecendecia);

    if (submenu.length > 0)
      menu = {
        icon: 'pi pi-fw pi-cog',
        label: 'Configuração da empresa',
        routerLink: null,
        items: submenu,
        idElement: 'menu-empresa'
      };
    return menu;
  }

  /**
   * Menu de pedido
   * @param routes
   * @returns
   */
  createMenuPedido(routes: IRoute[]) {
    const menu: RouterItemPg[] = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Pedidos',
          isSubMenu: false,
          routerLink: ['/pedidos'],
          icon: 'pi pi-fw pi-shopping-cart',
          idElement: 'menu-pedidos'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/pedidos'
          }
        ]
      }
    ]);
    return menu;
  }

  /**
   * Menu de tratamentos
   * @param routes
   * @returns
   */
  createMenuTratamento(routes: IRoute[]) {
    const menu: RouterItemPg[] = filterGrantMenuItens(routes, [
      {
        menuItem: {
          label: 'Tratamentos',
          isSubMenu: false,
          routerLink: ['/tratamentos'],
          icon: 'mdi mdi-account-injury-outline',
          idElement: 'menu-tratamentos'
        },
        matchBackendRoutes: [
          {
            method: 'POST',
            url: '/tratamentos'
          }
        ]
      }
    ]);
    return menu;
  }
}
